import axios from "axios";
import store from "../store";
import { clearUser } from '../utils/authentication';
import router from "../router";

export const pumatracApi = axios.create()

pumatracApi.defaults.baseURL = process.env.API_BASE

if(window.location.host.indexOf('pumatrac-web.view') >= 0 || window.location.host.indexOf('localhost') >= 0) pumatracApi.defaults.baseURL = 'https://pumatrac-api-staging.herokuapp.com/api';

pumatracApi.defaults.headers.common['Accept'] = 'application/json, text/plain, */*'
pumatracApi.defaults.headers.common['X-Client-Platform'] = 'web'
pumatracApi.defaults.headers.common['X-Client-Version'] = process.env.VERSION

// add auth token to request headers
pumatracApi.interceptors.request.use(function (config) {
    let authToken = store.state.user !== null && store.state.user.authToken !== undefined ? store.state.user.authToken : process.env.AUTH_TOKEN;

    if (authToken && config.baseURL.indexOf(pumatracApi.defaults.baseURL) === 0) {
        config.headers['Authorization'] = `Bearer ${authToken}`
    }

  return config
})


pumatracApi.interceptors.response.use(function (response) {
        return response;
    }, function (error) {

        // Handle backend user logout
        if(error.response.status === 401) {
            if(store.getters.user) {
                clearUser();
                router.push({name: 'Login', params: {redirect: router.currentRoute.path}});
            }
        }
        
        return Promise.reject(error);
    }
);